import { ChangeEvent, useState, useRef, useEffect } from 'react'
import { Icon } from 'assets/index'
import { useField } from '@unform/core'
import { Input, Span } from './style'
import {
  Placeholder,
  InputError,
  InputContainer,
} from '../FormCommomStyle/FormCommomStyle'

interface IInputProps {
  type: string
  // error?: any
  name: string
  placeholder?: string
  disabled?: boolean
  defaultValue?: string | number
  maxLength?: number
  onChange?: (_e: ChangeEvent<HTMLInputElement>) => void
  initialError?: string
  secondary?: boolean
  onKeyDown?: boolean
  step?: number
  min?: number
  hasAsterisk?: boolean
  small?: boolean
  large?: boolean
  customError?: string
  onBlur?: any
  dataTestId?: string
}

export default function InputComponent(props: IInputProps) {
  const {
    name,
    maxLength,
    type,
    placeholder,
    defaultValue,
    secondary,
    onChange,
    onKeyDown,
    hasAsterisk,
    disabled,
    small,
    large,
    initialError,
    customError,
    onBlur,
    dataTestId,
  } = props
  const [showPassword, setShowPassword] = useState<boolean>(false)
  const inputRef = useRef<any>(null)
  const { fieldName, registerField, error, clearError } = useField(name)
  const [inputError, setInputError] = useState(initialError)
  const [inputFocused, setInputFocused] = useState(false)
  const [isFocusedOrValid, setIsFocusedOrValid] = useState(
    !!defaultValue || defaultValue === 0
  )
  const handleFocus = () => {
    setInputFocused(true)
    clearError()
  }
  const handleBlur = () => {
    setInputFocused(false)
    onBlur && onBlur(inputRef.current?.value)
  }
  useEffect(() => {
    setInputError(error)
  }, [error])

  useEffect(() => {
    setInputError(customError)
  }, [customError])

  useEffect(() => {
    if (inputFocused || defaultValue || defaultValue === 0) {
      setIsFocusedOrValid(true)
    } else {
      setIsFocusedOrValid(false)
    }
  }, [inputFocused, defaultValue])

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef,
      getValue: (ref) => {
        return ref.current.value
      },
      setValue: (ref, evalue) => {
        ref.current.value = evalue
      },
      clearValue: (ref) => {
        ref.current.value = ''
      },
    })
  }, [fieldName, registerField])

  const handleChangeState = () => {
    setShowPassword((oldState) => {
      return !oldState
    })
  }

  return (
    <InputContainer small={small} large={large}>
      <div className="relative">
        <Placeholder isFocusedOrValid={isFocusedOrValid} isDisabled={disabled}>
          {placeholder}
          {hasAsterisk && <span className="asterisk"> * </span>}
        </Placeholder>
        <Input
          data-testid={dataTestId}
          error={error}
          ref={inputRef}
          placeholder={placeholder}
          {...props}
          maxLength={maxLength}
          name={name}
          type={showPassword ? 'text' : type}
          defaultValue={defaultValue}
          // value={value}
          onChange={onChange}
          onKeyDown={(e) => {
            if (!onKeyDown) return
            e.preventDefault()
          }}
          onBlur={handleBlur}
          onFocus={handleFocus}
        />
      </div>
      <InputError
        // {...rest}
        error={inputError}
        disabled={disabled}
        data-testid={`${dataTestId}-error`}
      >
        <img
          className="img-error"
          src={Icon('alert_circle.svg')}
          alt="error icon"
        />
        {inputError}
      </InputError>
    </InputContainer>
  )
}
